<template>
  <div v-if="loadComponent">
    <v-form>
      <v-container>
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" class="pb-0 mb-0">
            <v-btn outlined text @click.stop="sync" :loading="synching">Synchorize Pending Approval</v-btn>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <!-- <v-text-field label="Code" :class="classPadding" v-model="approver.approverGroupCode"></v-text-field> -->
            <v-select
              label="Approver Group"
              :class="classPadding"
              v-model="selectedGroupCode"
              :items="groups"
              item-value="approverGroupCode"
              item-text="approverGroupDesc"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
            <v-text-field
              label="Approver Code"
              :class="classPadding"
              v-model="approver.fullName"
              readonly
              clearable
            >
              <template slot="append">
                <v-icon @click.stop="searchUser">mdi-magnify</v-icon>
                <!-- <span class="required">*</span> -->
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Approver Order"
              :class="classPadding"
              v-model="approver.approverOrder"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-text-field
              label="Remarks"
              :class="classPadding"
              v-model="approver.remarks"
            ></v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
            <v-checkbox
              label="Active"
              :class="classPadding"
              v-model="approver.active"
            ></v-checkbox>
          </v-col>
        </v-row>
        <!-- <v-row cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-col cols="12" xs="12" sm="12" md="12" class="pb-0 mb-0">
            <v-checkbox label="Allow Signature" :class="classPadding" v-model="approver.allowSign"></v-checkbox>
            <v-file-input
              label="Signature"
              :class="classPadding"
              v-model="signature"
              :disabled="!approver.allowSign"
              accept="image/*"
            ></v-file-input>
          </v-col>
        </v-row>-->
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn
              color="success"
              :loading="isSaving"
              :class="classPadding"
              @click.stop="save"
              v-if="userAccess.add >= 1"
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-container>
      <list :key="componentKey" :group-code="selectedGroupCode">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
    </v-container>
    <v-dialog v-model="show" width="900" persistent v-if="show">
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-select
                label="Approver Group"
                :class="classPadding"
                v-model="editSelectedGroupCode"
                :items="groups"
                item-value="approverGroupCode"
                item-text="approverGroupDesc"
                clearable
              ></v-select>
            </v-col>-->
            <v-col cols="12" xs="12" sm="6" md="8" class="pb-0 mb-0">
              <v-text-field
                label="Approver Code"
                :class="classPadding"
                v-model="editApprover.fullName"
                readonly
                clearable
              >
                <template slot="append">
                  <v-icon @click.stop="searchUser">mdi-magnify</v-icon>
                  <!-- <span class="required">*</span> -->
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Approver Order"
                :class="classPadding"
                v-model="editApprover.approverOrder"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Remarks"
                :class="classPadding"
                v-model="editApprover.remarks"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="4" class="pb-0 mb-0">
              <v-checkbox
                label="Active"
                :class="classPadding"
                v-model="editApprover.active"
              ></v-checkbox>
            </v-col>
          </v-row>
          <!-- <v-row cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-col cols="12" xs="12" sm="12" md="12" class="pb-0 mb-0">
              <v-checkbox
                label="Allow Signature"
                :class="classPadding"
                v-model="editApprover.allowSign"
              ></v-checkbox>
              <v-file-input
                label="Signature"
                :class="classPadding"
                v-model="editSignature"
                :disabled="!editApprover.allowSign"
                accept="image/*"
              ></v-file-input>
              <v-checkbox
                label="Clear Image"
                :class="classPadding"
                v-model="editApprover.clearImage"
              ></v-checkbox>
              <div v-if="signatureSrc != null && fileUrl == '' || fileUrl == null">
                <v-img
                  v-bind:src="signatureSrc"
                  width="500"
                  height="200"
                  class="text-center"
                  contain
                  :class="classPadding"
                ></v-img>
              </div>

              <v-img
                v-bind:src="fileUrl"
                width="500"
                height="200"
                class="text-center"
                contain
                :class="classPadding"
                v-else
              ></v-img>
            </v-col>
          </v-row>-->
          <!-- <v-row>
          <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
            <v-btn color="success" :loading="isSaving" :class="classPadding" @click.stop="save">Save</v-btn>
          </v-col>
          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click.stop="show = false">Close</v-btn>
          <v-btn
            text
            color="success"
            @click.stop="update"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="700" v-model="userDialog" scrollable>
      <users-pagination :show-dense="false" :headers="usersHeaders">
        <template slot="actions" slot-scope="{ item }">
          <v-btn text @click.stop="selectUser(item)">Select</v-btn>
        </template>
        <template slot="card-actions">
          <v-spacer></v-spacer>
          <v-btn text @click.stop="userDialog = false" color="error"
            >close</v-btn
          >
        </template>
      </users-pagination>
    </v-dialog>
  </div>
</template>
<script>
// import { mapActions } from "vuex";
import List from "./List";
import eventBus from "../../../../../events/eventBus";
const API_ENDPOINT = "/api/approverMember";
const API_ENDPOINT_GROUP = "/api/approverGroup";
import UsersPagination from "../../../../admin/users/PaginatedList";
import userAccessMixin from "../../../../../mixins/userAccessMixin";
export default {
  metaInfo: {
    // title: "Pag-Ibig",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  components: {
    List,
    UsersPagination
  },
  data: () => ({
    classPadding: "my-0 py-0",
    isSaving: false,
    approver: {},
    componentKey: 0,
    show: false,
    editApprover: {},
    isUpdating: false,
    groups: [],
    selectedGroupCode: "",
    editSelectedGroupCode: "",
    userDialog: false,
    usersHeaders: [
      {
        text: "",
        sortable: false,
        value: "action"
      },
      {
        text: "Emp Code",
        align: "left",
        sortable: false,
        value: "empCode"
      },
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "fullName"
      }
    ],
    signature: null,
    editSignature: null,
    fileUrl: "",
    signatureSrc: null,
    onEdit: false,
    synching: false
  }),
  methods: {
    // ...mapActions("pagibig", ["selectPagibig"]),
    save() {
      this.approver.groupCode = this.selectedGroupCode;
      // console.log(this.approver);
      this.isSaving = true;
      var formData = new FormData();

      formData.append("json", JSON.stringify(this.approver));
      formData.append("signature", this.signature);
      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        // this.$axios
        //   .post(`${API_ENDPOINT}`, this.approver)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    edit(item) {
      this.show = true;
      this.onEdit = true;
      this.editApprover = Object.assign({}, item);
      this.editSelectedGroupCode = this.selectedGroupCode;
      if (item.signature == null) {
        this.signatureSrc = "";
      } else {
        this.signatureSrc = "data:image/jpeg;base64," + item.signature;
      }

      // console.log(item.signature);
      // this.editSignature = item.signature;
      //   this.$router.push(`/pagibig-setup/edit/${item.approverGroupCode}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.approver.apporverCode = "";
      this.approver.fullName = "";
      this.approver.approverOrder = null;
      this.approver.remarks = "";
      this.approver.allowSign = false;
      this.signature = null;
      this.approver.active = false;
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    },
    update() {
      this.isUpdating = true;
      this.editApprover.groupCode = this.editSelectedGroupCode;
      var formData = new FormData();
      this.editApprover.signature = null;
      formData.append("json", JSON.stringify(this.editApprover));
      formData.append("signature", this.editSignature);
      this.$axios({
        method: "PUT",
        url: `${API_ENDPOINT}`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        // this.$axios
        //   .put(`${API_ENDPOINT}`, this.editApprover)
        .then(({ data }) => {
          this.$toast.success(data.message);
          //   this.$router.push("/");
          this.show = false;
          this.forceRerender();
          this.editSignature = null;
          this.fileUrl = "";
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    getAllGroups() {
      this.loading = true;
      this.$axios
        .get(`${API_ENDPOINT_GROUP}`)
        .then(({ data }) => {
          this.groups = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchUser() {
      this.userDialog = true;
    },
    selectUser({ empCode, fullName }) {
      if (this.onEdit) {
        this.editApprover.approverCode = empCode;
        this.editApprover.fullName = fullName;
      } else {
        this.approver.approverCode = empCode;
        this.approver.fullName = fullName;
      }
      this.userDialog = false;
    },
    sync() {
      this.synching = true
      this.$axios.post(`${API_ENDPOINT}/sync`)
        .then(({ data }) => {
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
           this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.synching = false;
        })
    }
  },
  created() {
    this.getAllGroups();
    this.getUserAccessRights("PMEApprovS");
  },
  watch: {
    // $route(val) {
    //   if (val.name === "pme-approvers") {
    //     this.forceRerender();
    //   }
    // }
    selectedGroupCode() {
      this.forceRerender();
    },
    editSignature(val) {
      if (val === null) {
        this.fileUrl = null;
        // this.signatureSrc = "";
      } else {
        const fr = new FileReader();
        fr.readAsDataURL(val);
        fr.addEventListener("load", () => {
          // console.log(fr);
          this.fileUrl = fr.result;
          // this.file = val;
        });
      }
    },
    show(val) {
      if (!val) {
        this.onEdit = false;
      }
    }
  },
  mounted() {
    eventBus.$on("PME_APPROVER_GROUP", () => {
      this.getAllGroups();
    });
  }
};
</script>